import { type AppEnv } from '@dni-types/vite-env'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignTokenLogin } from '@hooks-api/fortune/useApiCampaignTokenLogin'
import { getOfficialWebsite } from '@utils/getWordPressOfficialWebsite'

interface UseFpTokenLoginServiceProps {
  code?: string
  redirectPath?: string
  env: AppEnv
}

export const useFpTokenLoginService = ({ code, redirectPath, env }: UseFpTokenLoginServiceProps) => {
  const { destructuredData: activityInfo } = useApiCampaignActivityInfo(code)
  const region = activityInfo?.region ?? 'TW'
  const projectCode = activityInfo?.brand_codes_info?.at(0)?.brand_code
  const officialWebsite = projectCode ? getOfficialWebsite(env)?.[projectCode] : null

  const officialWebsiteWithCountry = region === 'TW' ? '' : `${region.toLowerCase()}`
  const { trigger: _tokenLogin, isMutating } = useApiCampaignTokenLogin((code && officialWebsite) ? { code } : undefined)

  const wordPressTokenLogin = async () => {
    try {
      if (!code) {
        throw new Error('Campaign code is required')
      }
      const tokenLogin = await _tokenLogin({ code, redirect_path: `${officialWebsiteWithCountry}${redirectPath}` })
      window.location.href = tokenLogin.data.data.wordpress_login_url
    }
    catch (e) {
      console.error(e)
    }
  }

  const paymentExecuteFailWordPressTokenLogin = async () => {
    try {
      if (!code) {
        throw new Error('Campaign code is required')
      }
      if (!officialWebsite) {
        throw new Error('Official website not found')
      }
      const tokenLogin = await _tokenLogin({ code, redirect_path: `${officialWebsiteWithCountry}/my-account/order?tabValue=pending` })
      window.open(tokenLogin.data.data.wordpress_login_url, '_blank')
    }
    catch (e) {
      console.error(e)
    }
  }

  return {
    wordPressTokenLogin,
    paymentExecuteFailWordPressTokenLogin,
    isLoading: isMutating,
  }
}
